import stopsSaga from './stopsSaga';

export default stopsSaga;
